export default {
  header: 'Uudet tilaukset keskeytetty',
  text: 'Napauta mihin tahansa palauttaaksesi',
};
